import { useQuery } from '@tanstack/react-query';
import { api } from '@shared/api/client';
import { BITRIX_STORE } from '@shared/api/endpoints';
import { useBitrix24 } from '@shared/hooks/useBitrix24';
import { useTelegramStatus } from '@features/settings/hooks/useTelegram';
import type { StoreDashboard } from '@tailorcast/shared-types';

export function useStoreDashboard(period: string = 'today') {
  const { isBitrix24 } = useBitrix24();
  const { data: telegramStatus } = useTelegramStatus();

  return useQuery({
    queryKey: ['store-dashboard', period],
    queryFn: () => api.get<StoreDashboard>(`${BITRIX_STORE.DASHBOARD}?period=${period}`),
    enabled: isBitrix24 && telegramStatus?.linked === true,
    staleTime: 60_000,
    refetchInterval: 60_000,
  });
}
